import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";

import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import List from "./list components/List";
import { Pagination } from "../../components";
import SubNavbar from "../../components/SubNavbar";
import { CreateButton } from "../css components/Button";

export default function BrandAgencyList() {
  const axios = useAxios();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [brands, setBrands] = useState([]);
  const [page, setPage] = useState({ page: 1, totalCount: 0, lastCount: 0 });

  const { businessEntityID } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    setLoading(true);

    axios({
      url:
        "/brand?businessEntityId=" +
        businessEntityID +
        `&page=${page.page}&limit=10`,
    }).then((response) => {
      if (response.status) {
        if (response.data.parsedBrands.length > 0) {
          setPage((prev) => ({
            ...prev,
            totalCount: response.data.totalCount,
            lastPage: response.data.parsedBrands?.length < 10,
          }));

          setBrands(response.data?.parsedBrands);
        } else {
          setBrands([]);
        }
      }
      setLoading(false);
    });
  }, [axios, businessEntityID, page.page]);

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  return (
    <Fragment>
      <SubNavbar
        pageName={"Registered Brands"}
        buttons={[
          <CreateButton
            variant="contained"
            onClick={() =>
              navigate(
                pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true
              )
            }
          >
            Add New Brand
          </CreateButton>,
        ]}
      />

      <List brands={brands} loading={loading} />

      {!!page.totalCount && (
        <Grid item container display={"flex"} justifyContent={"center"}>
          <Pagination
            count={Math.ceil(page.totalCount / 10)}
            variant="outlined"
            color="secondary"
            page={page.page}
            onChange={(_, value) => handlePagination("index", value)}
          />
        </Grid>
      )}
    </Fragment>
  );
}
